import { render, staticRenderFns } from "./common-image-popup.vue?vue&type=template&id=5788da58&scoped=true&lang=pug&"
import script from "./common-image-popup.vue?vue&type=script&lang=js&"
export * from "./common-image-popup.vue?vue&type=script&lang=js&"
import style0 from "./common-image-popup.vue?vue&type=style&index=0&id=5788da58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788da58",
  null
  
)

export default component.exports